import React, { PureComponent } from 'react';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper';

class TableFooter extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { limitesCliente,cliente } = this.props;
        
        return (
            <tfoot>
                <tr className="tr-bold">
                    <td className="principal-td" colSpan="2">
                        <label className="label-secondary">
                            <span className="icon-available-limit22"></span>&nbsp;Límite global sin asignar:
                        </label>
                    </td>
                    <td className="td-algn td-algn-right">
                        <label className="label-secondary">
                            {
                                (limitesCliente.LimiteSinAsignar < 0 && cliente.Id >0) ?
                                    <div>$ {GlobalHelper.ConvertirNumeroSinDecimales(limitesCliente.LimiteSinAsignar)}
                                        <span className="glyphicon glyphicon-exclamation-sign" style={{ "color": "red" }}></span>
                                    </div> :
                                    <div>$ {cliente.Id>0 ? GlobalHelper.ConvertirNumeroSinDecimales(limitesCliente.LimiteSinAsignar):"0"}</div>
                            }
                        </label>
                    </td>
                    <td colSpan="3"></td>
                </tr>
            </tfoot>
        );
    }
}

export default TableFooter